import React from 'react';
import { Button, Container, Typography, Box } from '@mui/material';
import { toast } from 'sonner';

const SonnerTest = () => {
  const testToast = () => {
    toast.success("Teste de notificação!", {
      description: "Se você vê isso, o Sonner está funcionando corretamente.",
      duration: 5000,
    });
  };

  const testError = () => {
    toast.error("Erro de teste!", {
      description: "Esta é uma notificação de erro de teste.",
      duration: 5000,
    });
  };

  const testInfo = () => {
    toast.info("Informação de teste!", {
      description: "Esta é uma notificação informativa de teste.",
      duration: 5000,
    });
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>
          Teste do Sonner
        </Typography>

        <Typography variant="body1" sx={{ mb: 3 }}>
          Clique nos botões abaixo para testar as notificações:
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Button
            variant="contained"
            color="success"
            onClick={testToast}
            size="large"
          >
            Teste Sucesso
          </Button>

          <Button
            variant="contained"
            color="error"
            onClick={testError}
            size="large"
          >
            Teste Erro
          </Button>

          <Button
            variant="contained"
            color="info"
            onClick={testInfo}
            size="large"
          >
            Teste Info
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default SonnerTest;
